<template>
    <div class="container-new order-right-summary right-info-block" style="text-align: left;">

        <div class="order-instruction-header">
            <i class="ion-android-checkbox-outline header-icon"></i>
            <h2>Podsumowanie</h2>
        </div>
        <div class="ors-time-and-date" v-if="orderData.warehouse">
            <div class="col-auto col-divided"><strong>Typ usługi:</strong><em>Transport</em></div>
            <div class="col-auto col-divided"><strong>Punkt podjęcia:</strong>
                <em>{{orderData.warehouse.Name}} <br/>{{orderData.warehouse.Street}} {{orderData.warehouse.StreetNo}}<br/>
                {{orderData.warehouse.PostalCode}} {{orderData.warehouse.City}}</em>
            </div>
            <div v-if="step > 2" class="col-auto col-divided"><strong>Adres realizacji:</strong>
                <em>{{orderData.address.Street}} {{orderData.address.StreetNo}} <span v-if="orderData.address.ApartmentNo">/ {{orderData.address.ApartmentNo}}</span><span v-if="orderData.address.FloorNo"> ({{orderData.address.FloorNo}} piętro)</span><br/>{{orderData.address.PostalCode}} {{orderData.address.City}}</em>
            </div>
            <div class="col-auto col-divided" v-if="step === 6"><strong>Preferowany dzień dostawy:</strong><em>{{orderData.delivery.date.date}}</em></div>
            <div class="col-auto" v-if="step === 6"><strong>Przedział godzinowy:</strong><em>{{orderData.delivery.timePeriod}}</em></div>
            <div class="col-auto" v-show="orderData.delivery.distance"><strong>Dystans:</strong><em>{{orderData.delivery.distance}}</em></div>
            <div class="col-auto" v-show="orderData.delivery.distanceOutOfZone"><strong>Dystans poza strefą:</strong><em>{{orderData.delivery.distanceOutOfZone | formatDistance}} km</em></div>


            <div class="col-auto col-divided"  v-if="step > 3"><strong style="color: red;">Dane klienta:</strong>
                <em>
                    <br/>
                    {{orderData.customer.FirstName}}<br/>
                    {{orderData.customer.LastName}}<br/>
                    {{orderData.customer.MobilePhone}}<br/>
                    {{orderData.customer.Email}}
                </em>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'summaryBox',
        props: ['step', 'orderData'],
        data () {
            return {

            }
        },
        filters: {
            formatDistance: function (v) {
                return v.replace('-', '');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// SummaryBox.vue?eda5a8c4